'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var locale = {
    placeholder: 'Select time'
};
exports['default'] = locale;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/antd/lib/time-picker/locale/en_US.js
// module id = 361
// module chunks = 0